export const IS_LANGUAGE_DROPDOWN_OPENED = "IS_LANGUAGE_DROPDOWN_OPENED";
export const IS_SIGNUP_OPENED = "IS_SIGNUP_OPENED";
export const IS_SEARCH_OPENED = "IS_SEARCH_OPENED";
export const IS_HAMBURGER_OPENED = "IS_HAMBURGER_OPENED";
export const CLICK_AWAY = "CLICK_AWAY";
export const IS_LOGGED_IN_BOX_OPENED = "IS_LOGGED_IN_BOX_OPENED";
